var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.31253 0.724196C7.31253 0.323625 6.94944 0 6.50002 0C6.05061 0 5.68752 0.323625 5.68752 0.724196V6.21677L3.82384 4.55565C3.50646 4.27276 2.99103 4.27276 2.67364 4.55565C2.35626 4.83854 2.35626 5.29795 2.67364 5.58084L5.92365 8.47762C6.24104 8.76051 6.75647 8.76051 7.07385 8.47762L10.3239 5.58084C10.6412 5.29795 10.6412 4.83854 10.3239 4.55565C10.0065 4.27276 9.49105 4.27276 9.17367 4.55565L7.31253 6.21677V0.724196ZM1.62501 7.96616C0.728714 7.96616 0 8.61567 0 9.41455V10.1387C0 10.9376 0.728714 11.5871 1.62501 11.5871H11.375C12.2713 11.5871 13 10.9376 13 10.1387V9.41455C13 8.61567 12.2713 7.96616 11.375 7.96616H8.79788L7.64768 8.99135C7.01292 9.55713 5.98459 9.55713 5.34982 8.99135L4.20216 7.96616H1.62501ZM10.9688 9.2335C11.1304 9.2335 11.2854 9.29073 11.3997 9.39259C11.514 9.49445 11.5782 9.6326 11.5782 9.77665C11.5782 9.9207 11.514 10.0589 11.3997 10.1607C11.2854 10.2626 11.1304 10.3198 10.9688 10.3198C10.8072 10.3198 10.6522 10.2626 10.5379 10.1607C10.4236 10.0589 10.3594 9.9207 10.3594 9.77665C10.3594 9.6326 10.4236 9.49445 10.5379 9.39259C10.6522 9.29073 10.8072 9.2335 10.9688 9.2335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportReportIcon);
export default __webpack_public_path__ + "static/media/export-report-icon.d383a9465623c77b04a09ff64403bea2.svg";
export { ForwardRef as ReactComponent };